import { Component } from '@angular/core';

@Component({
  selector: 'app-academic-landing-page',
  templateUrl: './academic-landing-page.component.html',
  styleUrls: ['./academic-landing-page.component.scss']
})
export class AcademicLandingPageComponent {

}
